import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useLocation, useParams } from 'react-router-dom'

import { Box } from '@mui/material'

import GRTabNavigation from '../../../components/GRTabNavigation/GRTabNavigation'
import usePage from '../../../hooks/usePage'
import pageService from '../../../services/PageService'
import { FeaturedGamesTab } from '../../features/settings/components/FeaturedGamesTab/FeaturedGamesTab'
import { PerformanceRulesTab } from '../../features/settings/components/PerformanceRulesTab/PerformanceRulesTab'
import { SystemActionsTab } from '../../features/settings/components/SystemActionsTab/SystemActionsTab'

const settingsTabs: { id: string; nameKey: string; content: ReactNode }[] = [
  { id: 'system-actions', nameKey: 'internal-service-management:settings_tab_system_actions', content: <SystemActionsTab /> },
  { id: 'performance', nameKey: 'internal-service-management:settings_tab_performance', content: <PerformanceRulesTab /> },
  { id: 'featured-games', nameKey: 'internal-service-management:settings_tab_featured_games', content: <FeaturedGamesTab /> },
]

export const SettingsPage: FC = () => {
  usePage(pageService.getInternalPageWithId('internal-settings'))
  const { t } = useTranslation()
  const { tab } = useParams<{ tab?: string }>()
  const location = useLocation()
  const selectedIndex = settingsTabs.findIndex((candidate) => candidate.id === tab)

  if (selectedIndex < 0) return <Navigate to={`/internal/settings/${settingsTabs[0].id}`} replace />

  return (
    <Box>
      <GRTabNavigation
        tabs={settingsTabs.map(({ id, nameKey }) => ({ id, name: t(nameKey) }))}
        selectedTab={selectedIndex}
        pagePrefix="/internal/settings"
        query={location.search}
        sticky={false}
      />
      {settingsTabs[selectedIndex].content}
    </Box>
  )
}
